import * as ContextMenuPrimitive from '@radix-ui/react-dropdown-menu';

import { ContextMenuItem } from '../../primitives/context-menu';
import { cn } from '../../utils/cn';

import type { JSX } from 'react';

interface ContextMenuItemBooleanProps extends React.ComponentPropsWithoutRef<
  typeof ContextMenuPrimitive.Item
> {
  description?: string;
  off?: {
    icon?: JSX.Element;
    text?: string | JSX.Element;
  };
  on?: {
    icon?: JSX.Element;
    text?: string | JSX.Element;
  };
  value: boolean;
}

export function ContextMenuItemBoolean({
  description,
  off,
  on,
  value,
  ...props
}: ContextMenuItemBooleanProps) {
  const ping = (
    <span
      className={cn('ml-[0.1rem] size-3 rounded-full', {
        'bg-muted-foreground/50': value,
        'bg-success': !value,
      })}
    />
  );

  const icon = value ? off?.icon : on?.icon;

  return (
    <ContextMenuItem template="grid-icon-content" {...props}>
      <div className="flex justify-center">{on?.icon && off?.icon ? icon : ping}</div>
      <span className="grid">
        {value ? (off?.text ?? 'Desactivar') : (on?.text ?? 'Activar')}
        {description && <span className="text-xs text-muted-foreground">{description}</span>}
      </span>
    </ContextMenuItem>
  );
}
